module.exports = __webpack_public_path__ + "img/yim08.32eb6fae.jpg";